import type { ReactElement } from "react";
import { Skeleton, SkeletonStatus } from "@/components/atoms";
import "./LinkHub.scss";
import "./LinkHubSkeleton.scss";

const DEFAULT_SOCIAL_ICON_COUNT = 4;

export interface LinkHubSkeletonProps {
  sectionCount?: number;
  linksPerSection?: number;
  socialIconCount?: number;
  showSubtitle?: boolean;
}

/** Loading placeholder matching LinkHub landing layout. */
export function LinkHubSkeleton({
  sectionCount = 2,
  linksPerSection = 3,
  socialIconCount = DEFAULT_SOCIAL_ICON_COUNT,
  showSubtitle = true,
}: LinkHubSkeletonProps): ReactElement {
  return (
    <SkeletonStatus label="Cargando sitio...">
      <div className="landing__profile link-hub-skeleton__profile">
        <Skeleton
          variant="circle"
          borderWeight="strong"
          className="landing__picture link-hub-skeleton__picture"
        />
        <Skeleton
          variant="text"
          borderRadius="base"
          className="landing__title link-hub-skeleton__title"
        />
        {showSubtitle ? (
          <Skeleton
            variant="text"
            className="landing__subtitle link-hub-skeleton__subtitle"
          />
        ) : null}
        <div className="social-links" aria-hidden="true">
          {Array.from({ length: socialIconCount }).map((_, index) => (
            <span key={`link-hub-social-skeleton-${index}`} className="social-links__link">
              <Skeleton
                variant="circle"
                className="link-hub-skeleton__social-icon"
              />
            </span>
          ))}
        </div>
      </div>

      {Array.from({ length: sectionCount }).map((_, sectionIndex) => (
        <section
          key={`link-hub-section-skeleton-${sectionIndex}`}
          className="landing__section"
          aria-hidden="true"
        >
          <Skeleton
            variant="text"
            borderRadius="base"
            className="landing__section-title link-hub-skeleton__section-title"
          />
          <div className="landing__section-container">
            {Array.from({ length: linksPerSection }).map((__, linkIndex) => (
              <Skeleton
                key={`link-hub-link-skeleton-${sectionIndex}-${linkIndex}`}
                borderRadius="lg"
                className="link-hub-skeleton__link"
              />
            ))}
          </div>
        </section>
      ))}
    </SkeletonStatus>
  );
}
